<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  <new-ui-textarea
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [label]="props.label"
    [rows]="props.rows"
    [readonly]="props.readonly"
    [autoResize]="props.autoResize ?? props.grow ?? false"
    [required]="props.required"
    [badgeDisabled]="props.badgeDisabled"
    [dt]="props.dt"
    [dontUseReadOnlyWrapper]="props.dontUseReadOnlyWrapper"
    [propertyPath]="props.propertyPath"
  />

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
